<ion-header class="ion-no-border ion-header-modal-mobile" *ngIf="isTouch">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button
        id="back-modal-btn"
        data-cy="back-modal-btn"
        text=""
        (click)="navigateBack()"
      >
      </ion-back-button>
    </ion-buttons>
    <ion-label>
      {{ data.title }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-content-no-overflow">
  <div>
    <ion-label id="title" *ngIf="!isTouch">{{ data.title }}</ion-label>
    <ion-input
      aria-labelledby="title"
      data-cy="usf-filtering-text-entry-input-field"
      [placeholder]="data.placeHolderText"
      [appRegexInputValidator]="data.validationRegex"
      [maxlength]="maxLength"
      [(ngModel)]="data.searchText"
      (ngModelChange)="onTextEntryChange()"
    ></ion-input>
  </div>
</ion-content>

<ion-footer class="ion-footer-modal" *ngIf="isTouch">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="save-modal-btn"
        data-cy="save-modal-btn"
        class="usf-fill-green-dsktp-tblt-modal-button"
        (click)="navigateBack()"
        translate
      >
        {{ 'i18n.common.save' }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
